import { apiClient } from './client';

export const designationApi = {
  getAll:  ()       => apiClient.get('/designations'),
  create:  (data)   => apiClient.post('/designations', data),
  delete:  (id)     => apiClient.delete(`/designations/${id}`),
};
